import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {AppAutocomplete} from "@/autocomplete/AppAutocomplete";
import {AutocompleteProvider} from "@/autocomplete/context/GlobalContext";
import {ConfigProvider} from "@/ConfigProvider";

const rootElement = document.getElementById("algolia-autocomplete");
if (rootElement) {
    const rootNode = createRoot(rootElement);
    rootNode.render(
        <StrictMode>
            <ConfigProvider domElement={rootElement}>
                <AutocompleteProvider>
                    <AppAutocomplete/>
                </AutocompleteProvider>
            </ConfigProvider>
        </StrictMode>
    );
}
